import React, { useState } from "react";

import { Field, useFormikContext } from "formik";

import { UnitsForm } from "Hooks/useSelectUnits/interface";
import { RegionUnits } from "Hooks/useRegions/interface";

import { TextEllipsis } from "Utils/String";

import { CustomCheckbox } from "Components/Form/CustomCheckbox";

import Arrow from "Assets/Images/arrowAccordion.svg";

import { Container } from "Components/SubListCheckbox/style";

type UnitsPickerValues = {
  units: UnitsForm;
};

type UnitsSubListCheckboxProps = {
  region: RegionUnits;
  handleSelectUnits: (unitId: number) => void;
  handleSelectAllRegionUnits: (regionId: number) => void;
  readOnly?: boolean;
};

export const UnitsSubListCheckbox = ({
  region,
  handleSelectUnits,
  handleSelectAllRegionUnits,
  readOnly = false,
}: UnitsSubListCheckboxProps) => {
  const [open, setOpen] = useState(true);
  const { values } = useFormikContext<UnitsPickerValues>();

  return (
    <Container open={open} className="checkbox-units">
      <div className="head">
        <Field
          component={CustomCheckbox}
          type="checkbox"
          name="units"
          value={region?.id}
          label={region?.region}
          disabled={readOnly}
          checked={values.units.include.includes(region?.id)}
          onChange={() => handleSelectAllRegionUnits(region?.id)}
        />
        <div
          role="button"
          onKeyDown={() => setOpen(!open)}
          onClick={() => setOpen(!open)}
          tabIndex={0}
          className="arrow-container "
        >
          <img src={Arrow} alt="" className="arrow-button" />
        </div>
      </div>

      {region?.units?.map((unit) => (
        <ul key={unit.id}>
          <li>
            <Field
              component={CustomCheckbox}
              type="checkbox"
              name="units"
              value={unit.id}
              label={TextEllipsis(unit.name, 17)}
              disabled={readOnly}
              checked={values.units.include.includes(unit.id)}
              onChange={() => handleSelectUnits(unit.id)}
            />
          </li>
        </ul>
      ))}
    </Container>
  );
};
